import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { WeaknessesResponse } from '../../../../shared/vulns/types';

const fetchCweList = () => {
  return get<WeaknessesResponse>('/api/weaknesses');
};

/**
 * React Query hook for fetching the CWE (Common Weakness Enumeration) list.
 */
export function useFetchCweList() {
  return useQuery<WeaknessesResponse>({
    queryKey: ['weaknesses'],
    queryFn: fetchCweList,
    staleTime: 1000 * 60 * 10,
  });
}
